// Atmosfer (gelap/hujan/warna langit) yang ter-lerp mulus per frame dari mode langit.
import { skyAt, lerp3, jamWIB } from "./sky";

export function createAtmos() {
  return { dark: 0, rain: 0, top: [191, 227, 240], bot: [232, 244, 224] };
}

// Target atmosfer dari mode langit, lalu transisi mulus. Mengembalikan jam yang dipakai.
// "auto"/"day" (EDITOR) = selalu SIANG CERAH (agar walikota tidak mengedit dalam gelap saat jam nyata malam).
// "real" (PETA PUBLIK, mode malam otomatis) = mengikuti jam nyata WIB — fajar/senja/malam bertahap.
export function stepAtmos(atmos, skyMode) {
  let hour = 12, raining = false;
  if (skyMode === "real") hour = jamWIB();
  else if (skyMode === "night") hour = 0;
  else if (skyMode === "rain") { hour = 15; raining = true; }
  const target = skyAt(hour);
  let tDark = target.dark, tTop = target.top, tBot = target.bot;
  if (raining) {
    tDark = Math.max(tDark, 0.22);
    tTop = lerp3(tTop, [96, 106, 122], 0.55);
    tBot = lerp3(tBot, [150, 158, 170], 0.55);
  }
  // Transisi mulus (fajar/senja/pergantian mode terasa bertahap)
  const k = 0.045;
  atmos.dark += (tDark - atmos.dark) * k;
  atmos.rain += ((raining ? 1 : 0) - atmos.rain) * (raining ? 0.008 : 0.03);
  for (let i = 0; i < 3; i++) {
    atmos.top[i] += (tTop[i] - atmos.top[i]) * k;
    atmos.bot[i] += (tBot[i] - atmos.bot[i]) * k;
  }
  return hour;
}
